import React, { Fragment, useEffect, useState } from "react";
import withRouter from "components/Common/withRouter";
import { useDispatch, useSelector } from "react-redux";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { CardBody, CardTitle, Col, Container, Row, Table } from "reactstrap";
import Card from "components/PurpleTheme/Card";
import PropTypes from "prop-types";
import { useLocation } from 'react-router-dom';
import {
    createMsTeamsChannel as onCreateMsTeamsChannel
} from "../../store/msteams/actions";

const MSTeamsOnboarding = props => {

    document.title = "MS Teams | Authorization";

    const dispatch = useDispatch();

    // Get data from the query parameters of the URL
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const tenantId = searchParams.get('tenantId');
    const channelId = searchParams.get('channelId');
    const teamName = searchParams.get('teamName');
    const teamId = searchParams.get('teamId');

    function createMsTeamsChannel() {
        const data = {
            ms_tenant_id: tenantId,
            ms_channel_id: channelId,
            ms_team_id: teamId,
            name: teamName
        }
        dispatch(onCreateMsTeamsChannel(data));
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container>
                    <Row>
                        <Col lg="8">
                            <Breadcrumbs
                                title={"Microsoft Teams"}
                                breadcrumbItem={"Microsoft Teams"}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Card>
                            <CardBody>
                                <h1>Authorize Temperstack MS Teams App</h1>
                                <p> <strong>Tenant ID: </strong>{tenantId}</p>
                                <p> <strong>Channel ID: </strong>{channelId}</p>
                                <p> <strong>Team Name: </strong>{teamName}</p>
                                <p> <strong>Team ID: </strong>{teamId}</p>

                                <p>By authorizing the Temperstack MS Teams App, you will be able to receive alerts and notifications from Temperstack in this channel.</p>
                                <p>Click the "Authorize" button below to proceed.</p>

                                <button className="btn btn-primary text-center" onClick={() => { createMsTeamsChannel() }}>
                                    Authorize
                                </button>
                            </CardBody>
                        </Card>
                    </Row>
                </Container>
            </div>
        </React.Fragment >
    );
};

MSTeamsOnboarding.propTypes = {
    t: PropTypes.any,
};

export default withRouter(MSTeamsOnboarding);
